import RegistrationData from '@/classes/facturae/RegistrationData'
import PersonType from '@/classes/facturae/PersonType'
import ResidenceType from '@/classes/facturae/ResidenceType'
import Business from '@/classes/facturae/Business'
import Address from '@/classes/facturae/Address'
import ContactDetails from '@/classes/facturae/ContactDetails'
import AdminsitrativeCentre from '@/classes/facturae/AdminsitrativeCentre'
import AdminsitrativeCentreFACeB2B from '@/classes/facturae/AdminsitrativeCentreFACeB2B'
import FACeB2BIdentificatives from '@/classes/facturae/FACeB2BIdentificatives'
import TaxWithHeld from '@/classes/facturae/TaxWithHeld'
import InvoiceLine from '@/classes/facturae/InvoiceLine'
import Descuento from '@/classes/facturae/Descuento'
import Tax from '@/classes/facturae/Tax'
import PaymentMethod from '@/classes/facturae/PaymentMethod'
import FactoringAssignmentData from '@/classes/facturae/FactoringAssignmentData'
import Assignee from '@/classes/facturae/Assignee'
import FacturaeData from '@/classes/facturae/FacturaeData'

import convertFileToBase64 from '@/services/functions/convertFileToBase64'
import getNullableNumber from '@/services/functions/getNullableNumber'
import { preserveByPredicate } from '@/services/functions/preserve&discard'

function getBussinessFromSociedad (formBusiness, isAssignee = false) {
  const assignee = new Assignee()
  assignee.IdSociedad = formBusiness.IdSociedad || null
  assignee.IdSede = formBusiness.IdSede || null
  if (formBusiness.Address) {
    const receiverAddress = formBusiness.Address
    const address = new Address()
    address.AddressLine = receiverAddress.Address || null
    address.PostCode = receiverAddress.PostCode || null
    address.Town = receiverAddress.Town || null
    address.Province = receiverAddress.Province || null
    address.CountryCode = receiverAddress.CountryCode || null
    assignee.Address = address
  }

  if (formBusiness.Sociedad) {
    const formSociedad = formBusiness.Sociedad
    assignee.TIN = formSociedad.TIN || null
    assignee.ResidenceType = formSociedad.ResidenceType || ResidenceType.RESIDENTE
    assignee.PersonType = formSociedad.PersonType || PersonType.JURIDICA
    assignee.CorporateName = formSociedad.NameCorporateName || null
    assignee.PersonName = formSociedad.NameCorporateName || null
    assignee.FirstSurname = formSociedad.FirstSurname || null
    assignee.SecondSurname = formSociedad.SecondSurname || null

    if (formSociedad.RegistrationData) {
      const formRegistrationData = formSociedad.RegistrationData
      const registrationData = new RegistrationData()
      registrationData.Book = formRegistrationData.Book || null
      registrationData.RegisterOfCompaniesLocation = formRegistrationData.RegisterOfCompaniesLocation || null
      registrationData.Sheet = formRegistrationData.Sheet || null
      registrationData.Folio = formRegistrationData.Folio || null
      registrationData.Section = formRegistrationData.Section || null
      registrationData.Volume = formRegistrationData.Volume || null
      registrationData.AdditionalData = formRegistrationData.AdditionalData || null
      assignee.RegistrationData = registrationData
    }
  }

  if (formBusiness.ContactDetails) {
    const formContactDetails = formBusiness.ContactDetails
    const contactDetails = new ContactDetails()
    contactDetails.Telephone = formContactDetails.Telephone || null
    contactDetails.TeleFax = formContactDetails.TeleFax || null
    contactDetails.WebAddress = formContactDetails.WebAddress || null
    contactDetails.ElectronicMail = formContactDetails.ElectronicMail || null
    contactDetails.INETownCode = formContactDetails.INETownCode || null
    contactDetails.ContactPersons = formContactDetails.ContactPersons || null
    contactDetails.CnoCnae = formContactDetails.CnoCnae || null
    contactDetails.AdditionalDetails = formContactDetails.AdditionalDetails || null
    assignee.ContactDetails = contactDetails
  }

  if (isAssignee) {
    return assignee
  }

  const business = Object.assign(new Business(), assignee)
  if (formBusiness.CentrosAdministrativos?.length) {
    const formCentrosAdministrativos = formBusiness.CentrosAdministrativos
    business.AdminsitrativeCentres = business.AdminsitrativeCentres === null ? [] : business.AdminsitrativeCentres
    formCentrosAdministrativos.forEach(formCentroAdm => {
      const administrativeCenter = new AdminsitrativeCentre()
      administrativeCenter.CentreCode = formCentroAdm.CentreCode || null
      administrativeCenter.RoleCode = formCentroAdm.RoleCode || null
      administrativeCenter.Name = formCentroAdm.Name || null
      administrativeCenter.FirstSurname = formCentroAdm.FirstSurname || null
      administrativeCenter.SecondSurname = formCentroAdm.SecondSurname || null
      administrativeCenter.ContactDetails = formCentroAdm.ContactDetails || null
      administrativeCenter.PhysicalIGLN = formCentroAdm.PhysicalIGLN || null
      administrativeCenter.LogicalOperationalPoint = formCentroAdm.LogicalOperationalPoint || null
      administrativeCenter.CentreDescription = formCentroAdm.CentreDescription || null

      if (formCentroAdm.Address) {
        const admCenterAddress = formCentroAdm.Address
        const address = new Address()
        address.AddressLine = admCenterAddress.Address || null
        address.PostCode = admCenterAddress.PostCode || null
        address.Town = admCenterAddress.Town || null
        address.Province = admCenterAddress.Province || null
        address.CountryCode = admCenterAddress.CountryCode || null
        administrativeCenter.Address = address
      }
      business.AdminsitrativeCentres.push(administrativeCenter)
    })
  }

  if (formBusiness.CentrosAdministrativosFB2B?.length) {
    const formCentrosAdministrativosFB2B = formBusiness.CentrosAdministrativosFB2B
    business.AdminsitrativeCentresFACeB2B = business.AdminsitrativeCentresFACeB2B === null ? [] : business.AdminsitrativeCentresFACeB2B
    formCentrosAdministrativosFB2B.forEach(formCentroAdmFB2B => {
      const administrativeCenterFB2B = new AdminsitrativeCentreFACeB2B()
      administrativeCenterFB2B.Code = formCentroAdmFB2B.Code || null
      administrativeCenterFB2B.Name = formCentroAdmFB2B.Name || null
      administrativeCenterFB2B.Role = formCentroAdmFB2B.Role || null
      business.AdminsitrativeCentresFACeB2B.push(administrativeCenterFB2B)
    })
  }

  if (formBusiness.FACeB2BIdentificatives) {
    const formIdentificatives = formBusiness.FACeB2BIdentificatives
    const identificatives = new FACeB2BIdentificatives()
    identificatives.DIRE = formIdentificatives.DIRE || null
    identificatives.Name = formIdentificatives.Name || null
    business.FACeB2BIdentificatives = identificatives
  }

  return business
}

async function getPayloadFacturae (form, { includeFiles = true, overrideTemplate = null } = {}) {
  const payload = new FacturaeData()
  payload.serieFactura = form.serieFactura || null
  payload.numFactura = form.numFactura || null
  payload.dateEmision = form.dateEmision || null
  payload.albaran = form.albaran || null
  payload.pedido = form.pedido || null
  payload.tipoImpuestoFactura = form.tipoImpuestoFactura || null
  payload.observaciones = form.observaciones || null
  payload.numExpediente = form.numExpediente || null
  payload.dateExpediente = form.dateExpediente || null
  payload.numEmisor = form.numEmisor || null
  payload.dateEmisor = form.dateEmisor || null
  payload.codAsignacion = form.codAsignacion || null
  payload.dateReceptor = form.dateReceptor || null
  payload.dir3 = form.dir3 || null
  payload.numContrato = form.numContrato || null
  payload.codDepReceptor = form.codDepReceptor || null
  payload.cuotaSuplido = form.cuotaSuplido || null
  payload.periodoDesde = form.periodoDesde || null
  payload.periodoHasta = form.periodoHasta || null
  //   payload.tipoAsociado = form.tipoAsociado || null // TODO -> ¿Qué es?
  //   payload.fechaAplicacion = form.fechaAplicacion || null // TODO -> ¿Qué es?
  payload.idPlantilla = (overrideTemplate || form.template)?.idPlantilla || null
  payload.applyEquivalenceSurcharge = !!form.applyEquivalenceSurcharge

  if (form.issuer) {
    const formIssuer = form.issuer
    const seller = new Business()
    const address = new Address()
    address.AddressLine = formIssuer.Direccion || null
    address.PostCode = formIssuer.CodigoPostal || null
    address.Town = formIssuer.Poblacion || null
    address.Province = formIssuer.Provincia || null
    address.CountryCode = formIssuer.CodigoPais || null
    seller.Address = address

    const contactDetails = new ContactDetails()
    contactDetails.Telephone = formIssuer.Telefono || null
    seller.ContactDetails = contactDetails

    seller.IdCIFEmpresa = formIssuer.IdCIFEmpresa || null
    seller.CorporateName = formIssuer.RazonSocial || null
    seller.PersonName = formIssuer.PersonaFisicaNombre || null
    seller.FirstSurname = formIssuer.PersonaFisicaPrimerApellido || null
    seller.SecondSurname = formIssuer.PersonaFisicaSegundoApellido || null
    seller.TIN = formIssuer.CIF || null
    seller.PersonType = formIssuer.PersonaFisica ? PersonType.FISICA : PersonType.JURIDICA
    seller.ResidenceType = formIssuer.TipoResidencia || ResidenceType.RESIDENTE

    const formRegistrationData = preserveByPredicate(formIssuer, key => key.startsWith('Registro'))
    if (Object.values(formRegistrationData).some(value => ![undefined, null].includes(value))) {
      const registrationData = new RegistrationData()
      registrationData.Book = formRegistrationData.RegistroLibro
      registrationData.RegisterOfCompaniesLocation = formRegistrationData.RegistroRegistroMercantil
      registrationData.Sheet = formRegistrationData.RegistroHoja
      registrationData.Folio = formRegistrationData.RegistroFolio
      registrationData.Section = formRegistrationData.RegistroSeccion
      registrationData.Volume = formRegistrationData.RegistroTomo
      registrationData.AdditionalData = formRegistrationData.RegistroDatosAdiccionales
      seller.RegistrationData = registrationData
    }
    payload.seller = seller
  }

  if (form.receiver) {
    const formReceiver = form.receiver
    payload.buyer = getBussinessFromSociedad(formReceiver)
    payload.sendType = formReceiver.SendType || null
  }

  if (form.irpf) {
    const formIrpf = form.irpf
    const taxWithHeld = new TaxWithHeld()
    taxWithHeld.taxName = formIrpf.Name || null
    taxWithHeld.taxType = formIrpf.TaxType || '04'
    taxWithHeld.taxRate = getNullableNumber(formIrpf.TaxRate)
    payload.taxesWithHeld = taxWithHeld
  }

  if (form.invoiceLines?.length) {
    const formLines = form.invoiceLines
    payload.invoiceLines = []
    formLines.forEach(invoiceLine => {
      const line = new InvoiceLine()
      line.codProducto = invoiceLine.codProducto || null
      line.descripcion = invoiceLine.descripcion || null
      line.precioUnitario = getNullableNumber(invoiceLine.UnitPriceWithoutTax)
      line.cantidad = getNullableNumber(invoiceLine.cantidad)
      line.subtotal = getNullableNumber(invoiceLine.subtotal)
      line.total = getNullableNumber(invoiceLine.total)
      line.UnitOfMeasure = getNullableNumber(invoiceLine.UnitOfMeasure)
      line.totalConImpuesto = getNullableNumber(invoiceLine.totalConImpuesto)
      line.lineNumber = getNullableNumber(invoiceLine.lineNumber)
      if (invoiceLine.descuentos?.length) {
        const formDescuento = invoiceLine.descuentos[0]
        const descuento = new Descuento()
        descuento.descuento = (formDescuento.incluyeDescuento ? formDescuento.descuento : null) || null
        descuento.cuota = (formDescuento.incluyeDescuento ? null : formDescuento.cuota) || null
        if (formDescuento.incluyeDescuento ? (descuento.descuento || descuento.descuento === 0) : (descuento.cuota || descuento.cuota === 0)) {
          line.descuentos = descuento
        }
      }
      if (invoiceLine.Taxes?.length) {
        const formTaxes = invoiceLine.Taxes
        line.taxes = []
        formTaxes.forEach(lineTax => {
          const tax = new Tax()
          tax.taxType = lineTax.TaxType || null
          tax.taxRate = getNullableNumber(lineTax.TaxRate)
          tax.cuota = getNullableNumber(lineTax.cuota)
          tax.equivalenceSurcharge = form.applyEquivalenceSurcharge ? getNullableNumber(lineTax.EquivalenceSurcharge) : 0
          line.taxes.push(tax)
        })
      }
      line.AdditionalLineItemInformation = invoiceLine.additionalLineItemInformation || null
      payload.invoiceLines.push(line)
    })
  }

  if (form.paymentMethod) {
    const formPaymentMethod = form.paymentMethod
    const paymentMethod = new PaymentMethod()
    paymentMethod.formaPago = formPaymentMethod.formaPago || null
    paymentMethod.dateVencimiento = formPaymentMethod.dateVencimiento
    if (formPaymentMethod.account) {
      const formAccount = formPaymentMethod.account
      paymentMethod.iban = formAccount.IBANAccountNumber || null
      paymentMethod.bicSwift = formAccount.BIC || null
      paymentMethod.fechaMandato = formAccount.DomiciliationDate || null
      paymentMethod.toBeCredit = true
    }
    payload.paymentMethod = paymentMethod

    if (formPaymentMethod.useCesionario && formPaymentMethod.formaPago === '04') {
      const formCesionario = formPaymentMethod.cesionario
      const factoringAssignmentData = new FactoringAssignmentData()
      factoringAssignmentData.assignee = getBussinessFromSociedad(formCesionario, true)
      const factoringPaymentMethod = new PaymentMethod()
      factoringPaymentMethod.formaPago = formPaymentMethod.formaPago || null
      factoringPaymentMethod.dateVencimiento = formPaymentMethod.dateVencimiento
      if (formPaymentMethod.cesionarioAccount) {
        const formCesionarioAccount = formPaymentMethod.cesionarioAccount
        factoringPaymentMethod.iban = formCesionarioAccount.IBANAccountNumber || null
        factoringPaymentMethod.bicSwift = formCesionarioAccount.BIC || null
        factoringPaymentMethod.fechaMandato = formCesionarioAccount.DomiciliationDate || null
        factoringPaymentMethod.toBeCredit = true
      }
      factoringAssignmentData.paymentMethod = factoringPaymentMethod
      factoringAssignmentData.assignmentClauses = formCesionario.ClausulaCesion || null
      payload.factoringAssignmentData = factoringAssignmentData
    }
  }

  if (includeFiles) {
    const checkFile = form.file?.[0] ?? form.file
    if (checkFile && !Array.isArray(checkFile)) {
      payload.file = await convertFileToBase64(checkFile)
    }
    if (form.Adjuntos?.length) {
      payload.Adjuntos = await Promise.all(form.Adjuntos.map(file => convertFileToBase64(file)))
    }
  }
  return payload
}

export default getPayloadFacturae
